<template>
  <img src="@/assets/img/Icons/download-csv.svg" />
</template>

<script>
export default {};
</script>

<style></style>
